import { styled } from "@mui/material";

export const PageTitle = styled("h1")(({ theme }) => ({
  ...theme.typography.h1,
  width: "100%",
  boxSizing: "border-box",
  margin: "2rem 0",
  padding: "0 10px",
  textAlign: "center",
  fontSize: "clamp(2rem, 5vw, 4rem)",
  fontWeight: 600,
  lineHeight: 1.2,
}));
